import { createFileRoute } from '@tanstack/react-router'

import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { logListFilters } from '@/components/Internal/Logs/log-list-filters'
import { LogsOverview } from '@/components/Internal/Logs/LogsOverview'
import { LogsTable } from '@/components/Internal/Logs/LogsTable'

export const Route = createFileRoute('/internal/system/operations/logs')({
  validateSearch: listSearchValidator(logListFilters),
  component: LogsScreen,
})

function LogsScreen() {
  const filters = useListFilters(logListFilters, Route)

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <LogsOverview />
      <LogsTable filters={filters} card={false} />
    </div>
  )
}
